module.exports = __webpack_public_path__ + "img/YF-SFZ.65e1a785.png";